import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { BaseHttpService } from 'shared/base/_base-http.service';

import { Config } from 'shared/config/env.config';
import {catchError} from 'rxjs/operators';


@Injectable()
export class ScorecardService extends BaseHttpService {

  private scorecards: any;
  private selectedScorecardId: any;
  private selectedScorecardVarName: string;

  getScoreItem(itemDetailId: string|number, scorecardId: string|number): Observable<any> {
    // return Observable.of(_.cloneDeep(scoreData)).delay(1000);
    return this.http.get(`${Config.API}/score-item/${itemDetailId}/${scorecardId}`)
        .pipe(catchError(this.handleError.bind(this)));
  }

  getScorecard(scorecardId: string|number): Observable<any> {
    return this.http.get(`${Config.API}/scorecard/${scorecardId}`)
        .pipe(catchError(this.handleError.bind(this)));
  }

  getScorecards(brandId: string|number, hardRefresh: boolean = false): Observable<any> {
    return new Observable(observer => {
      if (this.scorecards && !hardRefresh && !_.isString(this.scorecards)) { // not error string
        observer.next(_.cloneDeep(this.scorecards));
        return observer.complete();
      } else {
        this.http.get(`${Config.API}/scorecards/${brandId}`)
            .pipe(catchError(this.handleError.bind(this)))
          .subscribe((scorecards: any) => {
            this.scorecards = scorecards;
            observer.next(_.cloneDeep(this.scorecards));
            observer.complete();
          });
      }
    });
  }

  getCatalogTotalScores(brandId: string|number, state: string): Observable<any> {
    return this.http.get(`${Config.API}/catalog-scores/${brandId}/${state}`)
        .pipe(catchError(this.handleError.bind(this)));
  }

  setSelectedScorecardId(scorecardId: string): void {
    this.selectedScorecardId = scorecardId;
    this.updateSelectedScorecardVarName();
    localStorage.setItem(this.selectedScorecardVarName, scorecardId);

    // clear previous variable - remove after tests passed
    localStorage.removeItem(`selectedScorecard.${this.brandService.getBrand()}`);
  }

  getSelectedScorecardId(): any {
    if (this.selectedScorecardId) {
      return this.selectedScorecardId;
    } else {
      this.updateSelectedScorecardVarName();
      let selectedScorecardId: any = localStorage.getItem(this.selectedScorecardVarName);

      if (!selectedScorecardId && this.scorecards) {
        const defaultScorecard = _.find(this.scorecards, 'default');
        if (defaultScorecard) {
          selectedScorecardId = defaultScorecard._id;
        } else {
          selectedScorecardId = this.scorecards[0]._id;
        }
        this.setSelectedScorecardId(selectedScorecardId);
      }
      this.selectedScorecardId = selectedScorecardId;
      return selectedScorecardId;
    }
  }

  clearData() {
    this.scorecards = undefined;
    this.selectedScorecardId = undefined;
    localStorage.removeItem(this.selectedScorecardVarName);
    this.selectedScorecardVarName = undefined;
  }

  updateSelectedScorecardVarName() {
    if (!this.selectedScorecardVarName) {
      this.selectedScorecardVarName = `selectedScorecardId.${this.brandService.getBrand()}`;
    }
  }
}
